module.exports = __webpack_public_path__ + "static/target-efeae353f3c3531d8a92791a4e821634.png";